import { queryOptions } from '@tanstack/react-query';

import { api } from '~/lib/api';
import { i18n } from '~/lib/i18n';

export function stagesQueryOptions(orgId: string, deptId: string) {
  return queryOptions({
    queryKey: ['workflow-stages', orgId, deptId] as const,
    queryFn: async () => {
      const response = await api.api.org[':orgId'].department[':deptId']['workflow-stages'].$get({
        param: { orgId, deptId }
      });
      if (!response.ok) throw new Error(i18n.t('errors.unexpected'));
      return response.json();
    }
  });
}
